import React, { useEffect, useRef, useState } from 'react';
import { Grid } from 'react-virtualized';
import 'react-virtualized/styles.css';
import FeaturesRow from "./FeaturesRow";
import {connect} from "react-redux";

const FeaturesGrid = ({ lookViewType, rows, featureGroup, isMobile, windowHeight, itemClickCallback, shouldShowFullHeight= false }) => {
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [gridWidth, setGridWidth] = useState(296);
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  useEffect(() => {
    if (containerRef.current && !shouldShowFullHeight) {
      setContainerHeight(containerRef.current.clientHeight);
    }
  }, [windowHeight, shouldShowFullHeight]);

  useEffect(() => {
    setGridWidth(isMobile ? 238 : 296);
  }, [isMobile]);

  // Configuring the grid layout
  let columnCount;
  let rowHeight;

  switch (lookViewType) {
    case 1:
      columnCount = 1;
      rowHeight = 104;
      break;
    case 2:
      columnCount = 2;
      rowHeight = 170;
      break;
    case 3:
      columnCount = 1;
      rowHeight = 320; // Increased row height
      break;
    case 4:
      columnCount = 3;
      rowHeight = 128;
      break;
    default:
      columnCount = 1;
      rowHeight = 135;
  }
  const columnWidth = Math.floor(gridWidth / columnCount) - 8 / columnCount; // Ensure width is an integer to avoid overflow
  const rowCount = Math.ceil(rows.length / columnCount);

  return (
    <div className="side-level2__content-grid" ref={containerRef}>
      <Grid
        width={gridWidth}
        height={shouldShowFullHeight ? rowCount * rowHeight : containerHeight} // Use full container height
        columnCount={columnCount}
        columnWidth={columnWidth}
        rowCount={rowCount}
        rowHeight={rowHeight}
        cellRenderer={({ columnIndex, key, rowIndex, style }) => {
          const index = rowIndex * columnCount + columnIndex;
          if (index >= rows.length) return null;
          return (
            <FeaturesRow
              key={key}
              style={style}
              feature={rows[index].part ? rows[index].part : rows[index]}
              featureGroup={featureGroup}
              index={index}
              activeItemIndex={activeItemIndex}
              setActiveItemIndex={setActiveItemIndex}
              itemClickCallback={itemClickCallback}
            />
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = (store) => {
  const { isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    isMobile,
    lookViewType,
  };
};

export default connect(mapStateToProps)(FeaturesGrid);
